export default "__VITE_ASSET__Dw_Fr3qG__"